import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withViewTransitions,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import {
  provideHttpClient,
  withInterceptors,
  withFetch,
} from '@angular/common/http';
import { provideNativeDateAdapter, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app.routes';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { mensajePlanoInterceptor } from '@core/interceptors/mensaje-plano.interceptor';
import { LocalNativeDateAdapter } from '@shared/components/datepicker/local-native-date.adapter';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding(), withViewTransitions(), withPreloading(PreloadAllModules)),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, mensajePlanoInterceptor])),
    provideNativeDateAdapter(),
    // Sobrescribe el DateAdapter de provideNativeDateAdapter() (el último
    // provider del mismo token gana) — NativeDateAdapter.parse() interpreta
    // strings ISO de solo fecha ("2026-01-01") como medianoche UTC, corriendo
    // la fecha un día (y en enero, un año) hacia atrás en zonas con offset
    // negativo. Bug real documentado, ver comentario en el adapter.
    { provide: DateAdapter, useClass: LocalNativeDateAdapter },
    // Locale del datepicker Material en español
    { provide: MAT_DATE_LOCALE, useValue: 'es' },
    // Sin esto, el overlay del calendario de SolDatepickerComponent (Material
    // CDK) no siempre se cierra solo tras seleccionar un día — bug real
    // documentado, reproducido en varios specs Cypress. Async (no
    // provideAnimations() síncrono) para no meter el motor de animaciones
    // en el bundle inicial.
    provideAnimationsAsync(),
  ],
};
